export default "__VITE_ASSET__hSB880wv__"